import { DateTime } from 'luxon';
import { Notify } from './Notification';

export const exampleNotifications: Notify[] = [
  {
    initiator: 'Blockbrain',
    iconImageUrl:
      'https://media.licdn.com/dms/image/C4E0BAQHcKMvqPEQk8A/company-logo_200_200/0/1671199177782/theblockbrain_logo?e=2147483647&v=beta&t=x2X-CzQztUaNvzjXPpr-q1ZE14yz3eNiSf35j3KJ4As',
    datetimeISO: DateTime.now().minus({ minutes: 2 }).toISO(),
    message:
      'Congratulations! You have won the BlockBrain lottery, and your 1,000 USDT has been invested in the project.',
  },
  {
    initiator: 'Blockbrain',
    iconImageUrl:
      'https://media.licdn.com/dms/image/C4E0BAQHcKMvqPEQk8A/company-logo_200_200/0/1671199177782/theblockbrain_logo?e=2147483647&v=beta&t=x2X-CzQztUaNvzjXPpr-q1ZE14yz3eNiSf35j3KJ4As',
    datetimeISO: DateTime.now().minus({ hours: 1 }).toISO(),
    message: 'New claim available now',
  },
];
